<app-side-menu>
  <div class="b2b-ops-page">
    <div class="page-header">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div>
          <button type="button" class="btn-back" (click)="navigateBack()"><i class="fas fa-arrow-left"></i></button>
          <h1 class="page-title"><i class="fas fa-tags me-2"></i>Tabela de preços</h1>
          <p class="page-subtitle" *ngIf="contractDisplayName">
            {{ contractDisplayName }}
            <span *ngIf="contractNumber"> · {{ contractNumber }}</span>
          </p>
        </div>
      </div>
    </div>

    <app-b2b-operational-nav *ngIf="contractId" [contractId]="contractId" active="faturas"></app-b2b-operational-nav>

    <div class="b2b-ops-card" *ngIf="!loading">
      <form [formGroup]="form">
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Diária moto reserva (R$)</label>
            <input class="form-control" type="number" step="0.01" formControlName="reserveDailyAmount">
          </div>
          <div class="col-md-4">
            <label class="form-label">Telemetria mensal por veículo (R$)</label>
            <input class="form-control" type="number" step="0.01" formControlName="telemetryMonthlyAmount">
          </div>
          <div class="col-md-4">
            <label class="form-label">Valor fixo de sinistro (R$)</label>
            <input class="form-control" type="number" step="0.01" formControlName="claimFixedAmount"
                   [disabled]="form.get('claimUseWinnerBudget')?.value">
          </div>
          <div class="col-md-12">
            <label class="form-check-label">
              <input class="form-check-input me-2" type="checkbox" formControlName="claimUseWinnerBudget">
              Usar orçamento vencedor do sinistro (em vez do valor fixo)
            </label>
          </div>
          <div class="col-md-12">
            <label class="form-label">Observações</label>
            <textarea class="form-control" rows="3" formControlName="notes"></textarea>
          </div>
        </div>

        <div class="mt-4">
          <app-button
            *appHasPermission="'B2BContracts.Edit'"
            text="Salvar"
            color="var(--success-color)"
            height="40px"
            [disabled]="saving || form.invalid"
            (buttonClick)="save()">
            <i class="fas fa-save me-2"></i>
          </app-button>
        </div>
      </form>
    </div>
  </div>
</app-side-menu>
